import { Loader } from '@mantine/core';
import classnames from 'classnames';
import { useState } from 'react';
import { invokeEvent } from 'shared-base';
import { useCustomEvent } from '../../hooks/useCustomEvent';
import { Image, Loading, Thumb } from './MaterialSelector.style';

export type MaterialSelectorCellProps = {
  value: string;
  item: Json;
  itemProps: any;
  onSelect: (material: Json) => void;
};

export function MaterialSelectorCell(props: MaterialSelectorCellProps) {
  const { value, item, itemProps } = props;
  const { index } = item;
  const [showLoader, setShowLoader] = useState(false);

  useCustomEvent('UNITY/texture/loaded', () => {
    setShowLoader(false);
  });

  if (!item || typeof index === 'undefined') return null;

  function onDragStart(ev: React.DragEvent) {
    ev.dataTransfer.setData('text/plain', item.id);
    invokeEvent('dragStart', { type: 'material' });
  }

  function onDragEnd(ev: React.DragEvent) {
    ev.preventDefault();
    invokeEvent('dragEnd');
  }

  function onPreview(item: any, open: boolean) {
    invokeEvent('material/preview', { item, open });
  }

  function onSelect(item: any) {
    setShowLoader(true);

    props.onSelect(item);
  }

  useCustomEvent('materialDropped', (data: Json) => {
    const { itemId } = data;
    if (item?.id !== itemId) return;
    props.onSelect(item);
  });

  const style = {
    backgroundImage: `url(${item.thumbUrl})`,
  };

  const className = classnames('mat', {
    selected: value === item.id,
  });

  const classNameImage = classnames('image', {
    loading: showLoader,
  });

  function renderLoader() {
    if (!showLoader) return null;

    return (
      <Loading>
        <Loader color='pink' />
      </Loading>
    );
  }

  return (
    <Thumb
      key={index}
      title={`${item.id}\n${item.name}\n${item.category}`}
      style={itemProps.style}
      className={className}
      onClick={() => onSelect(item)}
      onMouseOver={() => onPreview(item, false)}
      onContextMenu={(ev) => {
        ev.preventDefault();
        onPreview(item, true);
      }}
    >
      <Image
        draggable={true}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        className={classNameImage}
        style={style}
      />
      {renderLoader()}
    </Thumb>
  );
}
